import { ProductCategory } from './product-category';

export class HasProductCategory {
    productCategory: ProductCategory;
}
